 <script>
    import {onDestroy, onMount} from 'svelte';
    import {PRConnect} from "@projectroom/ui-lib";
    import {navigateTo} from 'svelte-router-spa';
    import {fade} from 'svelte/transition';
    import Select from 'svelte-select';
    import axios from "axios";
	import { accessToken } from '../store/auth-store';

    class PageInfo {
        constructor({page=1, perPageNum=20, totalCount=100}) {
            this.totalCount = totalCount;
            this.setPage(page, perPageNum); 
        }

        setPage(page=1, perPageNum=20) {
            this.page = page;
            this.perPageNum = perPageNum;
            this.showPage = 10;
            this.pageStartNum = (page - 1) * perPageNum;
            this.endPage = Math.ceil(page / this.showPage) * this.showPage;
            this.startPage = this.endPage - this.showPage + 1;
            let tempEndPage = Math.ceil(this.totalCount / perPageNum);
            if ( this.endPage > tempEndPage) {
                this.endPage = tempEndPage;
            }
            this.prev = this.startPage != 1;
            this.next = this.endPage * perPageNum < this.totalCount; 
            this.pageList=[]; 
            for (let i = this.startPage; i <= this.endPage; i++) { 
                this.pageList.push(i);
            }
        }

        getListNumber(index) {
            return (this.page - 1) * this.perPageNum + index;
        }
        clickPrev() {
            this.setPage(this.page - 1);
            getUserList();
        }
        clickNext() {
            this.setPage(this.page + 1);
            getUserList();
        }
        clickPage(page) {
            this.setPage(page);
            getUserList();
        }
        clickSearch() {
            this.setPage();
            getUserList();
        }
        enter(e) {
            if (e.key === "Enter") {
                this.clickSearch();
            }
        }
    }

    let userList = [];
    let options = { year: "numeric", month: "long", day: "numeric" };
    let searchText = '';
    let searchCondition;
    let isPhoneNoPopup = false;
    let pageInfo = new PageInfo({});
    let viewPhoneNo;
    let viewEmail;
    let viewName;
	let refIframe;
    
    const getUserList = (e) => {
        PRConnect.send("/api/Admin/getUserList", {...pageInfo, searchCondition, searchText}, data => {
            if (data.header.status === "success") {
                userList = data.result.userList;
                let totalCount = data.result.totalCount;
                pageInfo = new PageInfo({...pageInfo, totalCount});
            } 
		}, () => { navigateTo("/main"); });
    }

    const goToUserLogin = (userId) => {
        PRConnect.send("/api/Admin/setUserLoginByJWT", {userId}, data => {
            if (data.header.status === "success") {
				accessToken.set(data.result.accessToken);
                window.open("/main", "_blank");
            }
        });
    }

    const clickPhoneNo = (user) => {
        isPhoneNoPopup = true;
        viewEmail = user.emailId;
        viewPhoneNo = user.phoneNo;
        viewName = user.name;
    }

    onMount(() => {
        getUserList();
		const handleMessage = (event) => {
			// 메시지를 보내는 도메인(origin)을 확인하여 보안 강화
			if (event.origin === 'https://child-domain.com') {  // 자식 아이프레임의 도메인 주소
				console.log('자식에서 받은 메시지:', event.data);
			} else {
				console.log('안전하지 않은 도메인에서 메시지를 수신');
			}
		};
		// 메시지 이벤트 리스너 등록
		window.addEventListener('message', handleMessage);
    });

	const registerUserByCreepong = () => {
		const registerParam = {
			"creepongId": "MA_00000002"
		}
		PRConnect.send("/api/Creepong/registerUser", registerParam, data => {
            if (data.header.status === "success") {
                console.log("가입 성공");
            }
        });
	} 

	const clickIframeEvent = () => {
		const message = { targetUrl: "chat-viewer", creepongId: "MA_00000002", chatId:"mbvojnsqyl" };
		// const message = { targetUrl: "chat-builder", creepongId: "MA_00000002"};
		refIframe.contentWindow.postMessage(message, "https://dev-le868-igmigyozkq.user1.projectroom.cloud/landing");
	}

</script>
<div class="container home" in:fade>
    <div class="title-wrapper">
        <div class="title-inner">
            <div class="title1">Home</div>
            <div class="title-main">회원목록</div>
            <div class="title-sub">아바톡에 가입되어 있는 회원 목록입니다.</div>
        </div>
    </div>
    <div class="userList-wrapper">
        <div class="search-wrapper">
            <select bind:value={searchCondition}>
                <option value="id" selected>아이디</option>
                <option value="emailId">이메일</option>
                <option value="name">이름</option>
                <option value="phoneNo">연락처</option>
            </select>
            <input type="text" bind:value={searchText} on:keydown={(e)=> pageInfo.enter(e)}>
            <button on:click={getUserList}>
                검색
            </button>
			<!-- <button on:click={registerUserByCreepong}>
			크리퐁 회원가입 테스트
			</button>
			<button on:click={clickIframeEvent}>아이프레임이벤트전송</button> -->
        </div>
		<!-- <iframe class="iframe-wrapper" bind:this={refIframe} src="https://dev-le868-igmigyozkq.user1.projectroom.cloud/landing" /> -->
        <table>
            <tr class="tr-th">
                <th>#</th>
                <th class="table-email">이메일</th>
                <th class="table-name">이름</th>
                <th class="table-phone">연락처</th>
                <th class="table-join-date">가입일</th>
            </tr>
        {#each userList as user, index (index)}
            <tr>
                <td>{pageInfo.getListNumber(index+1)}</td>
                <td>{user.emailId}</td>
                <td>{user.name}</td>
                <td class="pointer" on:click={() => clickPhoneNo(user)}>확인</td>
                <td>{new Date(user.joinDate).toLocaleDateString("ko-KR", options)}</td>
                <td class="pointer" on:click={() => goToUserLogin(user.id)}>들어가기</td>
            </tr>
        {/each}
        </table>
        <div class="paging-wrapper">
            {#if pageInfo.prev}
            <div class="page-number" on:click={()=> pageInfo.clickPrev()}>◀︎</div>
            {/if}
            {#each pageInfo.pageList as page}
            <div class="page-number" class:active={pageInfo.page === page} on:click={() => pageInfo.clickPage(page)}>{page}</div>
            {/each}
            {#if pageInfo.next}
            <div class="page-number" on:click={()=> pageInfo.clickNext()}>▶︎</div>
            {/if}
        </div>
    </div>
</div>
<div class="ava-popup" class:show={isPhoneNoPopup}>
    <div class="popup-layer withdraw">
        <div class="titile-text popup">
            <div class="h1 margin20">회원 정보</div>
            <div class="title-sub popup">{viewName} / {viewEmail}</div>
            <div class="title-sub popup view-phoneNo">{viewPhoneNo}</div>
        </div>
        <div class="popup-button">
            <a href="#" class="close-button w-button" on:click={()=>isPhoneNoPopup = false}>닫기</a>
        </div>
    </div>
</div>
<style>
    .userList-wrapper {
        margin: 0 auto;
        margin-top: 40px;
		overflow: auto;
    	height: max-content;
    }
    .active {
        font-weight: bold;
    }
    .page-number {
        cursor: pointer;
        display: inline-block;
        padding: 12px;
    }
    td {
        padding: 12px;
        text-align: center;
    }
    td, th { 
        min-width: 100px;
    }
    .tr-th {
        border-bottom: 2px solid darkgray;
    }
    .table-phone {
        min-width: 300px;   
    }

    .table-email {
        min-width: 300px;
    }
    .table-name {
        min-width: 300px;
    }
    .paging-wrapper {
        display: flex;
        margin: 0 auto;
        width: max-content;
    }

    .search-wrapper {
        margin-bottom: 16px;
    }
    .popup-button {
        margin-top: 20px;
    }
    .view-phoneNo {
        font-size: 20px;
        font-weight: 700;
    }
	.iframe-wrapper {
		width: -webkit-fill-available;
		height: 1000px;
	}
</style>